import React, {useContext} from "react";
import {ActionContext} from "../components/hooks/provider";
import {LangManager} from "../components/i18n/langManager";

export default function Err() {
    const {actionState} = useContext(ActionContext)
    const langManager = LangManager(actionState.language)
    return (
        <div className={"flex items-center justify-center mt-10"}>
            <span className={"text-black text-lg font-semibold"}>{langManager.linkIsInvalid}</span>
        </div>
    )
}
